import { defineMessages } from 'react-intl-next';

export const messages: {
	addButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	colorCodeSelectorLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	colorInputLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	addButtonText: {
		id: 'company-hub.color-picker.custom-palette.add-button-text',
		description:
			'Button text of custom palette input field when on call to action, elevates custom input to curated palette',
		defaultMessage: 'Add',
	},
	colorCodeSelectorLabel: {
		id: 'company-hub.color-picker.custom-palette.color-code-selector-label',
		description: 'Accessible label for the color code format selector dropdown',
		defaultMessage: 'Color format',
	},
	colorInputLabel: {
		id: 'company-hub.color-picker.custom-palette.color-input-label',
		description: 'Accessible label for the color value input field',
		defaultMessage: 'Color value',
	},
});
